import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { AdminDashboard } from "@/sections/admin-dashboard";
import { ensureAdminClientAuth, type AdminBootstrapInfo } from "@/utils/adminAuth";
import "./admin.css";
import "@/sections/admin-dashboard/styles/admin-dashboard.css";

const AdminApp = () => {
  const [bootstrap, setBootstrap] = useState<AdminBootstrapInfo | null>(null);

  useEffect(() => {
    void ensureAdminClientAuth().then(setBootstrap);
  }, []);

  if (!bootstrap) {
    return <p className="admin-loading">Loading admin…</p>;
  }

  return <AdminDashboard bootstrap={bootstrap} />;
};

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <AdminApp />
  </StrictMode>
);

(import.meta.hot.data.root ??= createRoot(elem)).render(app);
